import Academies from './Academies';

export default Academies;
